import { render, staticRenderFns } from "./RatingIcon.vue?vue&type=template&id=532bb70c&scoped=true&"
import script from "./RatingIcon.vue?vue&type=script&lang=js&"
export * from "./RatingIcon.vue?vue&type=script&lang=js&"
import style0 from "./RatingIcon.vue?vue&type=style&index=0&id=532bb70c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532bb70c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VIcon})
